import React from 'react';
export function FooterSection() {
  return <footer className="py-8 px-4 bg-[#111827]" data-id="element-128">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-129">
        <p className="text-gray-400 text-xs md:text-sm" data-id="element-130">
          Keto Air Fryer Arg — Todos los derechos reservados. Producto digital
          con acceso inmediato tras el pago.
        </p>
      </div>
    </footer>;
}